export const formatDate = (
  date: string,
  locales?: Intl.LocalesArgument,
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow" | undefined,
  day?: "numeric" | "2-digit" | undefined,
  year?: "numeric" | "2-digit" | undefined
) => {
  const preparedDate = new Date(date);

  return preparedDate.toLocaleDateString(locales ? locales : "en-US", {
    month: month ? month : "short",
    day: day ? day : "numeric",
    year: year ? year : "numeric"
  });
};
